export default "__VITE_ASSET__Cv1eeOtO__"